import { DeserializedObject } from '@/src/lib/http/jsonapi/deserializer';
import { CalculatePriceRequestType, ConcreteProduct } from '@/src/lib/product/types';
import { DeserializedConcreteProduct } from '@/src/lib/catalog-search/types';
import { CalculatePriceRequestData } from '@/src/app/api/calculate-price/route';
import {
  getIsNeverOutOfStock,
  getMinimumOrderAmount,
  isProductBuyable,
} from '@/src/lib/product/business/product-stock';
import { getCurrencyFromItem, getProductPriceFromItem } from '@/src/lib/product/business/product-item';

export class CalculatePriceRequest implements CalculatePriceRequestType {
  public concreteProduct;
  public quantity;
  public lang;
  public pricingReference;
  public queryYourPrice;
  public queryStockQuantity: boolean;
  public accountId;

  constructor(
    concreteProduct: DeserializedObject<ConcreteProduct> | DeserializedConcreteProduct,
    quantity: number,
    lang: string,
    queryYourPrice?: boolean,
    queryStockQuantity?: boolean,
    accountNumber?: string,
    pricingReference?: string,
  ) {
    this.concreteProduct = concreteProduct;
    this.quantity = quantity !== undefined ? quantity : 1;
    this.lang = lang;
    this.accountId = accountNumber;
    this.pricingReference = pricingReference;
    this.queryYourPrice = queryYourPrice;
    this.queryStockQuantity = queryStockQuantity !== undefined ? queryStockQuantity : true;
  }

  public setQueryYourPrice(accountId: string, pricingReference?: string): CalculatePriceRequestType {
    this.queryYourPrice = true;
    this.accountId = accountId;
    this.pricingReference = pricingReference;
    return this.result;
  }

  public get result(): CalculatePriceRequestType {
    return {
      concreteProduct: this.concreteProduct,
      quantity: this.quantity,
      lang: this.lang,
      queryYourPrice: this.queryYourPrice,
      queryStockQuantity: this.queryStockQuantity,
      accountId: this.accountId,
      pricingReference: this.pricingReference,
    };
  }

  public get resultForClient(): CalculatePriceRequestData {
    return {
      quantity: this.quantity,
      lang: this.lang,
      queryYourPrice: this.queryYourPrice,
      queryStockQuantity: this.queryStockQuantity,
      accountId: this.accountId,
      pricingReference: this.pricingReference,
      product: {
        sku: this.concreteProduct.sku,
        minOrderAmount: getMinimumOrderAmount(this.concreteProduct),
        isNeverOutOfStock: getIsNeverOutOfStock(this.concreteProduct),
        price: getProductPriceFromItem(this.concreteProduct),
        currencyCode: getCurrencyFromItem(this.concreteProduct),
        isBuyable: isProductBuyable(this.concreteProduct),
      },
    };
  }
}
